import { render, staticRenderFns } from "./chips-list.vue?vue&type=template&id=21d485b4&scoped=true"
import script from "./chips-list.vue?vue&type=script&lang=js"
export * from "./chips-list.vue?vue&type=script&lang=js"
import style0 from "./chips-list.vue?vue&type=style&index=0&id=21d485b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d485b4",
  null
  
)

export default component.exports